<div class="host-view-voucher">
  <div
    class="content"
    *ngIf="pictureList.length > 0"
    [style.height]="type === 'credentials' ? '663px' : '572px'"
  >
    <div class="thumbnail">
      <div
        class="picture"
        [class.blue]="pic?.checked"
        *ngFor="let pic of pictureList; index as i"
        (click)="onClickPicture(pic, i)"
      >
        <div class="image-item" *ngIf="type !== 'credentials'">
          <img class="normal-img" [src]="pic?.url" alt="pic" />
        </div>
        <div class="image-item" *ngIf="type === 'credentials'">
          <div class="img-container">
            <img class="small-image" [src]="pic?.url" alt="pic" />
            <div class="delete" (click)="onClickDeletePicture($event, pic)">
              <img src="/assets/house/credentials_delete.png" />
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="type === 'credentials'">
        <nz-upload
          *ngIf="listOfImage?.length < maxSize"
          nzAction="/api/upload/image"
          [nzShowUploadList]="false"
          [nzBeforeUpload]="beforeUpload"
          [nzAccept]="'image'"
          (nzChange)="addPhotos($event)"
        >
          <div class="upload">
            <div class="upload-btn">
              <i nz-icon nzType="plus" nzTheme="outline"></i>
            </div>
          </div>
        </nz-upload>
      </div>
    </div>
    <div class="large-image">
      <div class="image">
        <img [src]="checkedPic?.large_url || checkedPic?.url" alt="pic" />
      </div>
      <div class="image-info" *ngIf="checkedPic?.info">
        {{ checkedPic?.info?.name }} /
        {{ getGender(checkedPic?.info?.gender) }} /
        {{ getIdType(checkedPic?.info?.id_type) }} /
        {{ checkedPic?.info?.id_number }} / {{ checkedPic?.info?.country }} /
        {{ checkedPic?.info?.birthday | dateformat: ['YMD'] }}
      </div>
      <div class="operate" *ngIf="type === 'credentials'">
        <button
          class="guest-dropdown-btn"
          nz-button
          nz-dropdown
          nzTrigger="click"
          nzOverlayClassName="check-guide-audit-dropdown"
          [(nzVisible)]="clientDropdownVisible"
          [nzBackdrop]="false"
          [nzDropdownMenu]="menu"
          [class.placeholder]="!selectedGuestName">
          {{ selectedGuestName || ('order.relate_credentials_to_guest' | translate)  }}
          <i nz-icon nzType="down"></i>
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <div class="menu-item" (click)="onClickDropdownMenuItem(-1)">不关联</div>

          <div
            class="menu-item"
            (click)="onClickDropdownMenuItem(guest.id)"
            *ngFor="let guest of relatedGuestList">
            <div class="info">
              <div class="guest-name">
                <div class="name">{{ guest?.name }}</div>
                <div *ngIf="guest?.gender">
                  <img
                    class="gender"
                    [src]="guest?.gender === 1
                        ? '/assets/guest/male.png'
                        : '/assets/guest/female.png'"/>
                </div>
              </div>
              <div class="labels" *ngIf="guest?.client_tags.length">
                <div
                  class="label"
                  *ngFor="let label of guest?.client_tags"
                  [style.background]="label?.color"
                >
                  {{ label?.name }}
                </div>
              </div>
            </div>
            <div class="phone">{{ guest?.phone ? guest?.phone : '-' }}</div>
            <div class="email">{{ guest?.email ? guest?.email : '-' }}</div>
            <div class="id">
              {{ guest?.idType }} {{ guest?.id_number }}
            </div>
          </div>

          <div class="menu-item" (click)="onClickDropdownMenuItem(-2)">
            <span class="main-color">
              +
              {{ "reservation.info.audit.btn.add_guest" | translate }}
            </span>
          </div>
        </nz-dropdown-menu>
      </div>
    </div>
  </div>
  <div *ngIf="pictureList.length === 0 && type === 'credentials'" class="empty">
    <img src="/assets/icon/no_data.png" />
    <p class="empty-info">
      <!-- 暂无证件 -->
      {{ 'order.no_credentials' | translate }}
    </p>
  </div>
  <div class="footer" *ngIf="type === 'credentials' && auditStatus !== AuditStatus.NoAuditRequired">
    <div class="status">
      <ng-container *ngIf="auditStatus === AuditStatus.Reject">
        <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
        <span>
          {{ "reservation.info.audit.status.wait_modify" | translate }}
<!--          待房客修改-->
        </span>
      </ng-container>
    </div>
    <div class="operators">
      <!-- http://mantis.xiaogetech.com/mantis/view.php?id=4992 -->
      <ng-container *ngIf="auditStatus === AuditStatus.Pending || auditStatus === AuditStatus.Reject">
        <button nz-button nzType="primary" (click)="onClickReject()">
          {{ "reservation.info.audit.btn.audit_reject" | translate }}
<!--          审核不通过-->
        </button>
        <button
          nz-button
          nzType="primary"
          (click)="updateAuditStatus(AuditStatus.Approve)"
        >
          <!-- 审核通过 -->
          {{ 'order.pass_examination' | translate }}
        </button>
      </ng-container>
      <button
        nz-button
        nzType="primary"
        *ngIf="auditStatus === AuditStatus.Approve"
        (click)="updateAuditStatus(AuditStatus.Pending)"
      >
        <!-- 撤销审核 -->
        {{ 'order.revoke_examination' | translate }}
      </button>
    </div>
  </div>
</div>

<ng-template #rejectTpl>
  <div class="reject-template">
    <div class="tip">
      <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
      <span>
        {{ "reservation.info.audit.reject_modal.tip" | translate }}
<!--        房客可在入住指南中查看原因-->
      </span>
    </div>
    <div class="form" [formGroup]="rejectForm">
      <div class="form-item">
        <div class="label">
          {{ "reservation.info.audit.reject_modal.item.reason" | translate }}
<!--          原因-->
        </div>
        <div class="control">
          <textarea
            formControlName="reason"
            nz-input
            cols="30"
            rows="5"
            [placeholder]="'reservation.info.audit.reject_modal.item.placeholder' | translate" style="resize:none"></textarea>
        </div>
      </div>
    </div>
  </div>
</ng-template>
